import { render, staticRenderFns } from "./StorageSpaceCreateScreen.vue?vue&type=template&id=7fafbd3e&"
import script from "./StorageSpaceCreateScreen.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceCreateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports